var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8559 1H15.1273C14.2045 1 13.4565 1.74806 13.4565 2.67083V8.39937C13.4565 9.32218 14.2045 10.0702 15.1273 10.0702H20.8559C21.7787 10.0702 22.5267 9.32218 22.5267 8.39937V2.67083C22.5267 1.74806 21.7787 1 20.8559 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5112 15.8109L19.1732 12.4729C18.8595 12.1603 18.4347 11.9849 17.9919 11.9849C17.5491 11.9849 17.1242 12.1603 16.8106 12.4729L13.4726 15.8109C13.1598 16.1245 12.9841 16.5493 12.9841 16.9922C12.9841 17.4351 13.1598 17.86 13.4726 18.1735L16.8106 21.5114C17.1241 21.8243 17.5489 22 17.9919 22C18.4348 22 18.8597 21.8243 19.1732 21.5114L22.5112 18.1735C22.8241 17.8601 23 17.4352 23 16.9922C23 16.5492 22.8241 16.1243 22.5112 15.8109Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3994 1H3.67084C2.74807 1 2 1.74806 2 2.67083V8.39937C2 9.32218 2.74807 10.0702 3.67084 10.0702H9.3994C10.3222 10.0702 11.0703 9.32218 11.0703 8.39937V2.67083C11.0703 1.74806 10.3222 1 9.3994 1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3994 12.4572H3.67084C2.74807 12.4572 2 13.2053 2 14.128V19.8565C2 20.7794 2.74807 21.5274 3.67084 21.5274H9.3994C10.3222 21.5274 11.0703 20.7794 11.0703 19.8565V14.128C11.0703 13.2053 10.3222 12.4572 9.3994 12.4572Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreSquare);
export default __webpack_public_path__ + "static/media/more-square.fda49d81c6ebfbb887115d3defcb20ed.svg";
export { ForwardRef as ReactComponent };